module.exports = __webpack_public_path__ + "img/template6.fd3d4aad.png";